module.exports = __webpack_public_path__ + "img/mountains.03fdc543.webp";